import { RouteProps } from "react-router-dom";
import { authPagesMenu } from "../menu";
// import { pageLayoutTypesPagesMenu } from "../menu";
import DefaultFooter from "../pages/_layout/_footers/DefaultFooter";

const footers: RouteProps[] = [
  // { path: pageLayoutTypesPagesMenu.blank.path, element: null },
  { path: authPagesMenu.login.path, element: null },
  { path: authPagesMenu.signUp.path, element: null },
  { path: authPagesMenu.verifyOtp.path, element: null },
  { path: "/apartment-admin", element: null },
  { path: authPagesMenu.page404.path, element: null },
  // { path: demoPagesMenu.knowledge.subMenu.grid.path, element: null },
  { path: "*", element: <DefaultFooter /> },
];

export default footers;
